package com.example.borshi.web.model

/**
 * Represents a single item within a protein plan's mix. (JS/WEB version)
 */
data class PlanMixItem(
    val productId: String = "",
    val productName: String = "",
    val productImage: String = "",
    val productPrice: Double = 0.0,
    val qty: String = "" // e.g., "500g"
)
